import { forwardRef } from 'react';

import cn from 'classnames';

import OTooltip from '../OTooltip';
import ButtonSpinner from './ButtonSpinner';

import { IObuttonProps } from './types';

import './OButton.scss';

const OButton = forwardRef<HTMLButtonElement, IObuttonProps>(function OButton(
  {
    icon,
    text = '',
    size = 'medium',
    variant = 'primary',
    outlined = false,
    loading = false,
    grayOutlined = false,
    toolTipContent,
    isDisabled = false,
    isTextButton = false,
    isTooltipCapitalized = false,
    toolTipPlacement,
    onClick,
    startIcon,
    classes,
    isToolTipSmall = false,
    backgroundColor = 'var(--icon-bg)',
    tooltipWidth = '360px',
    ...rest
  },
  ref
) {
  // Wrap button in OTooltip only if tooltip content exists
  const button = (
    <button
      ref={ref}
      className={cn(
        'o-button',
        variant,
        size,
        {
          outlined,
          'text-button': isTextButton,
          'gray-outlined': grayOutlined,
          disabled: isDisabled,
        },
        classes?.container
      )}
      onClick={(e) => !isDisabled && onClick?.(e)}
      disabled={isDisabled || loading}
      {...rest}
    >
      <div className="button-content">
        {startIcon && <div className="button-icon">{startIcon}</div>}
        {text && <span className="button-text">{text}</span>}
        {icon && <div className="button-icon">{icon}</div>}
        {loading && <ButtonSpinner />}
      </div>
    </button>
  );

  if (!toolTipContent) {
    return button;
  }

  return (
    <OTooltip
      isCapitalized={isTooltipCapitalized}
      title={toolTipContent}
      isSmall={isToolTipSmall}
      placement={toolTipPlacement}
      backgroundColor={backgroundColor}
      customStyles={{ tooltip: { maxWidth: tooltipWidth } }}
      slotProps={{
        popper: {
          sx: {
            pointerEvents: 'none',
          },
        },
        tooltip: {
          sx: {
            cursor: isDisabled ? 'not-allowed' : 'pointer',
          },
        },
      }}
    >
      <span className={cn('button-tooltip-container', { disabled: isDisabled })}>{button}</span>
    </OTooltip>
  );
});

export default OButton;
